<template>
  <div>
    <div
      class="file-item flex align-center justify-between"
      v-for="(v, index) in pattern"
      :key="index"
      
    >
      <a class="flex align-center over-hiden" :title="v.name"
      target="_blank" :href="v.path" style="width:85%">
        <img :src="util.get_image_icon(v.name)" class="icon-doc" />
        <span class="margin-left-10 text-333">{{ v.name }}</span>
      </a>
      <img
        v-if="status == 0 || status == 4"
        src="../../../assets/images/patternMaker/ico_delete.png"
        @click.stop="removeFile(index)"
        class="delete-img"
      />
    </div>
  </div>
</template>

<script>
import Popup from "@/components/Popup.vue";
import util from "@/utils/util";
export default {
  name: "PatternFile",
  data() {
    return {
      files: [],
      util,
    };
  },
  components: {
    Popup,
  },
  props: {
    pattern: {
      type: Array,
    },
    status: {
      type: Number,
    },
  },
  created() {
    this.files = this.pattern;
  },
  methods: {
    removeFile(index) {
      this.files.splice(index, 1);
      this.$emit("uploadPattern", this.files);
    },
  },
};
</script>
<style lang="scss" scoped>
.file-item {
  height: 76px;
  background: #f8f9fb;
  border-radius: 4px;
  margin-bottom: 16px;
  padding: 0 12px;
  .icon-doc {
    width: 42px;
    height: 42px;
  }
  .download-img {
    width: 20px;
    height: 20px;
  }

  .download {
    font-weight: 400;
    font-size: 14px;
    color: #0d99ff;
    margin-left: 5px;
  }
  .delete-img {
    width: 20px;
    height: 20px;
  }
}
</style>
